import React from 'react'
import PropTypes from 'prop-types'

const Complete = ({
   nextUrl
 }) => (
  <div id='signup__complete'>
    <div class="govuk-notification-banner govuk-notification-banner--success" 
        role="region" 
        aria-labelledby="govuk-notification-banner-title" 
        data-module="govuk-notification-banner"
        >
      <div class="govuk-notification-banner__header">
          <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
            Sign up complete
        </h2>
      </div>
      <div class="govuk-notification-banner__content">
        <p class="govuk-body">Your account has been created.</p>
      </div>
    </div>

  <a href={nextUrl}>
    <button
      id='signup-modal-submit-success'
      type="submit"
      className='great-ds-button govuk-!-margin-bottom-9'
    >
      <span class="great-ds-button__text">
        Continue
      </span>
    </button>
  </a>
  </div>
)

export default Complete


Complete.propTypes = {
  nextUrl: PropTypes.string.isRequired,
}

